import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../styles/max-container-width/max-container-width.style';
import { extraSmallPaddingVerticalBox } from '../view-style';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 8,
    ...extraSmallPaddingVerticalBox,
    borderBottomWidth: 1,
  },
  innerContainer: {
    ...maxContainerWidthStyle,
    flexDirection: 'row',
  },
});
